import { SCROLL_TARGET_NAME_ATTRIBUTE } from '../config/constants';

export class TargetSelectorFactory {
  static get(name: string): string {
    return `[${SCROLL_TARGET_NAME_ATTRIBUTE}="${name}"]`;
  }
}
